import { fetchConToken , fetchSinToken} from '../utils/fetch.ts';
import { APP_CONFIG } from '../config/app.ts'

export const editarAlumnoGira = async (idalumno, data) => {
  try {
    const resp = await fetchConToken("giras/editar-alumno-gira", {
      idalumno,
      data
    }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const creaGira = async (gira) => {
    try {
      const resp = await fetchConToken("giras/crear-gira",gira, "POST");
      const body = await resp.json();
      return body;
    } catch (error) {
      return { error: true };
    }
  };

  
  export const editarGira = async (gira) => {
    try {
      const resp = await fetchConToken("giras/editar-gira",gira, "POST");
      const body = await resp.json();
      return body;
    } catch (error) {

      return { error: true };
    }
  };

  export const updateAlumno = async (editData) => {
    try {
      const resp = await fetchConToken("giras/editar-alumno", editData, "POST");
      const body = await resp.json();
      return body;
    } catch (error) {
      return { error: true };
    }
  };

  export const actualizarContactoAdulto = async (aluId, usuCelular, idparentesco) => {
    try {
      const resp = await fetchConToken("giras/actualizar-contacto-adulto", {
        aluId,
        usuCelular,
        idparentesco
      }, "POST");
      const body = await resp.json();
      return body;
    } catch (error) {
      return { error: true };
    }
  };

export const getGiras = async () => {
  try {
    const resp = await fetchConToken("giras/listado-giras", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}; 

export const getGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/obtener-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}  

export const getMiGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/obtener-mi-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}  

export const descargarPlanillaAduana = async (id) => {
  
  try {
    const resp = await fetchConToken(`giras/descargar-planilla-aduana/${id}`, {}, "GET");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const descargarLogAcceso = async (id) => {
  try {
    const resp = await fetchConToken(`giras/descargar-log-acceso/${id}`, {}, "GET");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const generarCodigoQRPasajeros = async (giraId) => {
  try {
    const resp = await fetchConToken(`giras/generar-qr-pasajeros/${giraId}`, {}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true, message: error.message };
  }
}

/**
 * Obtiene el listado de pasajeros de una gira usando hash
 * Requiere contraseña para acceso
 * @param {string} hash - Hash único de la gira
 * @param {string} password - Contraseña de acceso
 * @returns {Promise<Object>} Datos de gira y pasajeros
 */
export const obtenerPasajerosPorHash = async (hash, password) => {
  try {
    const resp = await fetchSinToken(`giras/listar-pasajeros/${hash}`, {password}, 'POST');
    const body = await resp.json();
    return { ...body, status: resp.status };
  } catch (error) {
    return { error: true, message: error.message };
  }
}

/**
 * Obtiene el listado de giras del año en curso
 * Requiere contraseña para acceso
 * @param {string} password - Contraseña de acceso
 * @returns {Promise<Object>} Lista de giras del año
 */
export const obtenerGirasPublicas = async (password) => {
  try {
    const resp = await fetchSinToken(`giras/listar-giras-publicas`, {password}, 'POST');
    const body = await resp.json();
    return { ...body, status: resp.status };
  } catch (error) {
    return { error: true, message: error.message };
  }
}

export const descargarPlanillaInterna = async (id) => {
  try {
    const resp = await fetchConToken(`giras/descargar-planilla-interna/${id}`, {}, "GET");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getApoderdosGiras = async (id) => {
  try {
    const resp = await fetchConToken(`giras/apoderados-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getAlumnosGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/alumnos-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getAlumno = async (id) => {
  try {
    const resp = await fetchConToken(`giras/alumno/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
} 


export const getAlumnosEliminadosGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/alumnos-eliminados-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getDocumentosGira = async (id) => {
  try {
    const resp = await fetchConToken(`giras/documentos-gira/${id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}



export const enviarListadoapoderados = async (idfile, idgira) => {
  try {
    const resp = await fetchConToken("giras/enviar-listado-apoderado", { idfile, idgira }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const cargarNominaAlumnos = async (idfile, idgira) => {
  try {
    const resp = await fetchConToken("giras/cargar-nomina-alumnos", { idfile, idgira }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const enviarDocumentos = async (idfile, idgira) => {
  try {
    const resp = await fetchConToken("giras/enviar-documentos", { idfile, idgira }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const eliminarAlumnoGira = async (idalumno, idgira) => {
  try {
    const resp = await fetchConToken("giras/eliminar-alumno-gira", { idalumno, idgira }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const agregareliminarAlumnoGira  = async (idalumno, idgira, alumno) => {
  try {
    const resp = await fetchConToken("giras/activar-alumno-gira", { idalumno, idgira, alumno }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}


export const agregarAlumnoGira  = async (idapoderado, idgira, alumno) => {
  try {
    const resp = await fetchConToken("giras/agregar-alumno-gira", { idapoderado, idgira, alumno }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const cuotasAlumno = async (idalumno) => {
  try {
    const resp = await fetchConToken(`giras/cuotas-alumno/${idalumno}`, {}, "GET");
    const body = await resp.json();
    return body;
  }
  catch (error) {
    return { error: true };
  }
}

export const registrarPagosFuncionario = async (pagos,multasModificadas, detalleModificadas, dolar) => {
  try {
    const resp = await fetchConToken("giras/registrar-pagos-funcionario", {pagos,multasModificadas, detalleModificadas, dolar}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getMisGiras = async () => {
  try {
    const resp = await fetchConToken("giras/mis-giras", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}; 

//Pagos Webpay
export const registrarPagosWebpay = async (pagos, dolar) => {
  try {
    const resp = await fetchConToken("webpay/registrar-pagos-webpay", { pagos, dolar }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}




export const commitPagosWebpay = async (tokenws) => {
  try {
    const resp = await fetchConToken("webpay/commit-pagos-webpay",{tokenws: tokenws}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

//Pagos getnet
export const registrarPagosGetnet = async (pagos) => {
  try {
    const resp = await fetchConToken("getnet/registrar-pagos-getnet", pagos, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const commitPagosGetnet = async (tokenws) => {
  try {
    const resp = await fetchConToken("getnet/commit-pagos-getnet",{tokenws: tokenws}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

//Pagos Khipu
export const registrarPagosKhipu = async (pagos) => {
  try {
    const resp = await fetchConToken("khipu/registrar-pagos-khipu", pagos, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}


export const commitPagosKhipu = async (tokenws) => {
  try {
    const resp = await fetchConToken("khipu/commit-pagos-khipu",{tokenws: tokenws}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

// Funciones para documentos del apoderado
export const cargarDocumentoApoderado = async (aluId: number, girId: number, docTipo: string, archivo: File) => {
  try {
    const formData = new FormData();
    formData.append('aluId', aluId.toString());
    formData.append('girId', girId.toString());
    formData.append('docTipo', docTipo);
    formData.append('document', archivo);

    const token = localStorage.getItem('token');
    const resp = await fetch(`${APP_CONFIG.apiUrl || 'http://localhost:3001'}/giras/cargar-documento-apoderado`, {
      method: 'POST',
      headers: {
        'x-token': token
      },
      body: formData
    });
    
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al cargar documento:', error);
    return { error: true, msg: 'Error al cargar documento' };
  }
};

export const obtenerDocumentosApoderado = async (aluId: number, girId: number) => {
  try {
    const resp = await fetchConToken(`giras/documentos-apoderado/${aluId}/${girId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener documentos:', error);
    return { error: true, msg: 'Error al obtener documentos' };
  }
};

export const eliminarDocumentoApoderado = async (docId: number) => {
  try {
    const resp = await fetchConToken('giras/eliminar-documento-apoderado', { docId }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al eliminar documento:', error);
    return { error: true, msg: 'Error al eliminar documento' };
  }
};

export const descargarDocumentoApoderado = async (docId: number) => {
  try {
    const token = localStorage.getItem('token');
    const resp = await fetch(`${APP_CONFIG.apiUrl || 'http://localhost:3001'}/giras/descargar-documento-apoderado/${docId}`, {
      method: 'GET',
      headers: {
        'x-token': token
      }
    });

    if (!resp.ok) {
      throw new Error('Error descargando documento');
    }

    const blob = await resp.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = resp.headers.get('content-disposition')?.split('filename=')[1]?.replace(/"/g, '') || 'documento';
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error al descargar documento:', error);
  }
};

// Reembolso
export const solicitarReembolso = async (alu_id: number, motivo: string, archivo: File | null) => {
  try {
    const formData = new FormData();
    formData.append('alu_id', alu_id.toString());
    formData.append('motivo', motivo);
    if (archivo) {
      formData.append('archivo', archivo);
    }

    const token = localStorage.getItem('token');
    const resp = await fetch(`${APP_CONFIG.apiUrl || 'http://localhost:3001'}/giras/solicitar-reembolso`, {
      method: 'POST',
      headers: {
        'x-token': token
      },
      body: formData
    });

    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al solicitar reembolso:', error);
    return { error: true };
  }
};

export const obtenerSolicitudReembolso = async (alu_id: number) => {
  try {
    const resp = await fetchConToken(`giras/solicitud-reembolso/${alu_id}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const aprobarReembolso = async (alu_id: number, monto: number | string, comentario: string) => {
  try {
    const resp = await fetchConToken("giras/aprobar-reembolso", {
      alu_id,
      monto,
      comentario
    }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const rechazarReembolso = async (alu_id: number, comentario: string) => {
  try {
    const resp = await fetchConToken("giras/rechazar-reembolso", {
      alu_id,
      comentario
    }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const descargarArchivoReembolso = async (filId: number) => {
  try {
    const token = localStorage.getItem('token');
    const resp = await fetch(`${APP_CONFIG.apiUrl || 'http://localhost:3001'}/giras/descargar-archivo-reembolso/${filId}`, {
      method: 'GET',
      headers: {
        'x-token': token || ''
      }
    });

    if (!resp.ok) {
      throw new Error('Error descargando archivo');
    }

    const blob = await resp.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = resp.headers.get('content-disposition')?.split('filename=')[1]?.replace(/"/g, '') || 'archivo';
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error al descargar archivo:', error);
  }
};


export const cloneGira = async (giraId: number) => {
  try {
    const resp = await fetchConToken("giras/clonar-gira", { giraId }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al clonar gira:', error);
    return { error: true, msg: 'Error al clonar gira' };
  }
};

// Información aceptada del usuario
export const verificarInformacionAceptada = async () => {
  try {
    const resp = await fetchConToken("giras/verificar-informacion-aceptada", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al verificar información aceptada:', error);
    return { error: true };
  }
};

export const aceptarInformacion = async () => {
  try {
    const resp = await fetchConToken("giras/aceptar-informacion", {}, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al aceptar información:', error);
    return { error: true };
  }
};

export const obtenerTodosReembolsos = async () => {
  try {
    const resp = await fetchConToken("giras/reembolsos-todos", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener reembolsos:', error);
    return { error: true, reembolsos: [] };
  }
};

// Responsable de gira
export const obtenerResponsableGira = async (giraId) => {
  try {
    const resp = await fetchConToken(`giras/responsable-gira/${giraId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener responsable de gira:', error);
    return { error: true };
  }
};

export const cambiarResponsableGira = async (giraId, nuevoApoId) => {
  try {
    const resp = await fetchConToken("giras/cambiar-responsable-gira", { giraId, nuevoApoId }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al cambiar responsable de gira:', error);
    return { error: true };
  }
};

// Solicitud de cupos
export const crearSolicitudCupo = async (solicitudData) => {
  try {
    const resp = await fetchConToken("giras/solicitud-cupo", solicitudData, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al crear solicitud de cupo:', error);
    return { error: true };
  }
};

export const obtenerMisSolicitudesCupo = async (giraId) => {
  try {
    const resp = await fetchConToken(`giras/mis-solicitudes-cupo/${giraId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener mis solicitudes de cupo:', error);
    return { error: true, data: [] };
  }
};

export const obtenerSolicitudesCupoGira = async (giraId) => {
  try {
    const resp = await fetchConToken(`giras/solicitudes-cupo-gira/${giraId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener solicitudes de cupo de la gira:', error);
    return { error: true, data: [] };
  }
};

export const obtenerDetalleSolicitudCupo = async (socId) => {
  try {
    const resp = await fetchConToken(`giras/detalle-solicitud-cupo/${socId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener detalle de solicitud:', error);
    return { error: true };
  }
};

export const aprobarSolicitudCupo = async (socId, formValues) => {
  try {
    const resp = await fetchConToken(`giras/aprobar-solicitud-cupo/${socId}`, formValues, "PUT");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al aprobar solicitud:', error);
    return { error: true };
  }
};

export const rechazarSolicitudCupo = async (socId, razonRechazo) => {
  try {
    const resp = await fetchConToken(`giras/rechazar-solicitud-cupo/${socId}`, { razon_rechazo: razonRechazo }, "PUT");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al rechazar solicitud:', error);
    return { error: true };
  }
};

export const obtenerCoordinadoresGira = async (giraId) => {
  try {
    const resp = await fetchConToken(`giras/coordinadores-gira/${giraId}`, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener coordinadores de gira:', error);
    return { error: true };
  }
};

export const asignarCoordinadoresGira = async (giraId, coordinadorIds) => {
  try {
    const resp = await fetchConToken("giras/asignar-coordinadores", { giraId, coordinadorIds }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al asignar coordinadores:', error);
    return { error: true };
  }
};

/**
 * Descarga reporte de alumnos con columnas seleccionadas
 * @param {number} giraId - ID de la gira
 * @param {Array} columnas - Array con las columnas seleccionadas
 * @returns {Promise<Blob>} Blob del archivo Excel
 */
export const descargarReporteAlumnosColumnas = async (giraId, columnas) => {
  try {
    const resp = await fetchConToken("giras/descargar-reporte-alumnos-columnas", {
      giraId,
      columnas
    }, "POST");
    const body = await resp.blob();
    return body;
  } catch (error) {
    console.error('Error al descargar reporte:', error);
    return { error: true };
  }
};

  export default {
    creaGira,
    editarGira,
    cuotasAlumno,
    registrarPagosFuncionario,
    getMisGiras,
    cloneGira,
    verificarInformacionAceptada,
    aceptarInformacion,
    obtenerTodosReembolsos,
    obtenerCoordinadoresGira,
    asignarCoordinadoresGira
  }